import { render, staticRenderFns } from "./AsCloneButton.vue?vue&type=template&id=59b3b769&scoped=true"
import script from "./AsCloneButton.vue?vue&type=script&lang=js"
export * from "./AsCloneButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b3b769",
  null
  
)

export default component.exports